import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService, ClientProfileService, ProjectService,} from '../../_services/index';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ValidateUrl} from "../../helpers/url.validator";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";
import {RecommendedSolutionService} from "../../_services/recommendedSolution.service";

@Component({
    standalone: false,
  selector: 'add-link-recommended-solution-component',
  templateUrl: 'add-link-recommended-solution.component.html'
})

export class AddLinkRecommendedSolutionComponent implements OnInit {
  quizForm: FormGroup;
  entity;
  url: string = '';
  costOptions: string[] = ['$', '$$', '$$$'];
  configDetailOptions: string[] = ['Available', 'Not Available'];

  constructor(
    formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddLinkRecommendedSolutionComponent>,
    public projectService: ProjectService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public service: RecommendedSolutionService,
    public router: Router,
    public clientProfileService: ClientProfileService,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public authenticationService: AuthenticationService) {
    let entity = this.data.entity || {};
    this.entity = entity;

    this.quizForm = formBuilder.group({
      recommendedSolutionId: [entity.recommendedSolutionId || 0, '', []],
      name: [entity.name || '', [Validators.required]],
      url: [entity.url || ''],
      description: [entity.description || '', [Validators.required]],
      configDetails: [entity.configDetails|| '',[Validators.required]],
      cost: [entity.cost|| '', [Validators.required]],
      contact: [entity.contact || ''],
      listId: [entity.listId || ''],
    });
  }

  ngOnInit() {
  }

  generate(): void {
    if (!this.quizForm.valid) {
      Object.keys(this.quizForm.controls).forEach(field => {
        const control = this.quizForm.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    this.dialogRef.close({value: this.quizForm.value});
  }

  onClose(): void {
    this.dialogRef.close();
  }

  addReference() {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
    };

    const selectDialogRef = this.dialog.open(SelectControlItemComponent, config);

    selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.service.addReference(this.entity.recommendedSolutionId, data.controlItemId).subscribe(id => {
          this.entity.controlItemReferences.push({
            controlItemRecommendedSolutionId: id,
            controlId: data.complianceAreaControlId,
            complianceAreaName: data.complianceAreaName
          })
        });
      }
    });
  }

  removeReference(c) {
    this.service.removeReference(c.controlItemRecommendedSolutionId).subscribe(id => {
      this.entity.controlItemReferences = this.entity.controlItemReferences.filter(v => v.controlItemRecommendedSolutionId !== c.controlItemRecommendedSolutionId);
    });
  }
}
